export default __webpack_public_path__ + "static/media/1989.80a321c5.png";